import { Button } from '@/components/buttons/Button'
import { Flex } from '@/components/Flex'
import { Tooltip } from '@/components/Tooltip'
import { useBrowserOS } from '@/hooks/useBrowserOS'
import { CommandIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'

interface QuickNavigationButtonProps {
  onClick: () => void
}

const ICON_SIZE = 14

export const QuickNavigationButton = ({ onClick }: QuickNavigationButtonProps) => {
  const { t } = useTranslation()

  const browserOS = useBrowserOS()

  return (
    <Tooltip title={t('components.quickNavigation.button')} placement="bottom">
      <Button onClick={onClick} type="ghost">
        <Flex gap={8} align="center">
          {browserOS === 'Mac' ? (
            <CommandIcon size={ICON_SIZE} />
          ) : (
            <kbd className={styles.keyboard}>Ctrl</kbd>
          )}
          <kbd className={styles.keyboard}>K</kbd>
        </Flex>
      </Button>
    </Tooltip>
  )
}
